import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-grid");
import { globalStyle, style } from '@vanilla-extract/css';
import { breakpoints, tokens } from '@paypalcorp/pp-react-theme';
const gridGutter = '0.75rem';
const breakpointsMap = {
  xs: `(min-width: ${breakpoints.mediaXs})`,
  sm: `(min-width: ${breakpoints.mediaSm})`,
  md: `(min-width: ${breakpoints.mediaMd})`,
  lg: `(min-width: ${breakpoints.mediaLg})`,
  xl: `(min-width: ${breakpoints.mediaXl})`,
  xxl: `(min-width: ${breakpoints.mediaXxl})`
};
const getColSpan = (breakpointName, span) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      msFlex: `0 0 ${span / 12 * 100}%`,
      flex: `0 0 ${span / 12 * 100}%`,
      maxWidth: `${span / 12 * 100}%`
    }
  }
}, `grid-col-${breakpointName}-${span}`);
const getOffsetSpan = (breakpointName, span) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      marginLeft: `${span / 12 * 100}%`
    }
  }
}, `grid-col-offset-${breakpointName}-${span}`);
const getOrderSpan = (breakpointName, span) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      order: span
    }
  }
}, `grid-col-order-${breakpointName}-${span === -1 ? 'first' : span === 13 ? 'last' : span}`);
const getDisplayBreakpoint = (breakpointName, display) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      display: `${display} !important`
    }
  }
}, `grid-col-display-${breakpointName}-${display}`);
const getJustifyContentBreakpoint = (breakpointName, className, value) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      justifyContent: value
    }
  }
}, `grid-row-justify-content-${breakpointName}-${className}`);
const getAlignSelfBreakpoint = (breakpointName, className, value) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      alignSelf: value
    }
  }
}, `grid-row-align-self-${breakpointName}-${className}`);
const getAlignContentBreakpoint = (breakpointName, className, value) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      alignContent: value
    }
  }
}, `grid-row-align-content-${breakpointName}-${className}`);
const getAlignItemsBreakpoint = (breakpointName, className, value) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      alignItems: value
    }
  }
}, `grid-row-align-items-${breakpointName}-${className}`);
const getFlexBreakpoint = (breakpointName, value) => style({
  '@media': {
    [breakpointsMap[breakpointName]]: {
      msFlexDirection: value,
      flexDirection: value
    }
  }
}, `grid-row-flex-${breakpointName}-${value}`);
const getCol = span => style({
  msFlex: `0 0 ${span / 12 * 100}%`,
  flex: `0 0 ${span / 12 * 100}%`,
  maxWidth: `${span / 12 * 100}%`
}, `grid-col-${span}`);
const formBaseStyles = {
  paddingTop: tokens.space[100],
  paddingBottom: tokens.space[100]
};
const colBaseStyles = {
  position: 'relative',
  width: '100%',
  minHeight: '1px',
  paddingRight: gridGutter,
  paddingLeft: gridGutter
};
export const offset = {
  1: style({
    marginLeft: '8.333333333333332%'
  }, 'grid-col-offset-1'),
  2: style({
    marginLeft: '16.666666666666664%'
  }, 'grid-col-offset-2'),
  3: style({
    marginLeft: '25%'
  }, 'grid-col-offset-3'),
  4: style({
    marginLeft: '33.33333333333333%'
  }, 'grid-col-offset-4'),
  5: style({
    marginLeft: '41.66666666666667%'
  }, 'grid-col-offset-5'),
  6: style({
    marginLeft: '50%'
  }, 'grid-col-offset-6'),
  7: style({
    marginLeft: '58.333333333333336%'
  }, 'grid-col-offset-7'),
  8: style({
    marginLeft: '66.66666666666666%'
  }, 'grid-col-offset-8'),
  9: style({
    marginLeft: '75%'
  }, 'grid-col-offset-9'),
  10: style({
    marginLeft: '83.33333333333334%'
  }, 'grid-col-offset-10'),
  11: style({
    marginLeft: '91.66666666666666%'
  }, 'grid-col-offset-11'),
  12: style({
    marginLeft: '100%'
  }, 'grid-col-offset-12'),
  xs: {
    1: getOffsetSpan('xs', 1),
    2: getOffsetSpan('xs', 2),
    3: getOffsetSpan('xs', 3),
    4: getOffsetSpan('xs', 4),
    5: getOffsetSpan('xs', 5),
    6: getOffsetSpan('xs', 6),
    7: getOffsetSpan('xs', 7),
    8: getOffsetSpan('xs', 8),
    9: getOffsetSpan('xs', 9),
    10: getOffsetSpan('xs', 10),
    11: getOffsetSpan('xs', 11),
    12: getOffsetSpan('xs', 12)
  },
  sm: {
    1: getOffsetSpan('sm', 1),
    2: getOffsetSpan('sm', 2),
    3: getOffsetSpan('sm', 3),
    4: getOffsetSpan('sm', 4),
    5: getOffsetSpan('sm', 5),
    6: getOffsetSpan('sm', 6),
    7: getOffsetSpan('sm', 7),
    8: getOffsetSpan('sm', 8),
    9: getOffsetSpan('sm', 9),
    10: getOffsetSpan('sm', 10),
    11: getOffsetSpan('sm', 11),
    12: getOffsetSpan('sm', 12)
  },
  md: {
    1: getOffsetSpan('md', 1),
    2: getOffsetSpan('md', 2),
    3: getOffsetSpan('md', 3),
    4: getOffsetSpan('md', 4),
    5: getOffsetSpan('md', 5),
    6: getOffsetSpan('md', 6),
    7: getOffsetSpan('md', 7),
    8: getOffsetSpan('md', 8),
    9: getOffsetSpan('md', 9),
    10: getOffsetSpan('md', 10),
    11: getOffsetSpan('md', 11),
    12: getOffsetSpan('md', 12)
  },
  lg: {
    1: getOffsetSpan('lg', 1),
    2: getOffsetSpan('lg', 2),
    3: getOffsetSpan('lg', 3),
    4: getOffsetSpan('lg', 4),
    5: getOffsetSpan('lg', 5),
    6: getOffsetSpan('lg', 6),
    7: getOffsetSpan('lg', 7),
    8: getOffsetSpan('lg', 8),
    9: getOffsetSpan('lg', 9),
    10: getOffsetSpan('lg', 10),
    11: getOffsetSpan('lg', 11),
    12: getOffsetSpan('lg', 12)
  },
  xl: {
    1: getOffsetSpan('xl', 1),
    2: getOffsetSpan('xl', 2),
    3: getOffsetSpan('xl', 3),
    4: getOffsetSpan('xl', 4),
    5: getOffsetSpan('xl', 5),
    6: getOffsetSpan('xl', 6),
    7: getOffsetSpan('xl', 7),
    8: getOffsetSpan('xl', 8),
    9: getOffsetSpan('xl', 9),
    10: getOffsetSpan('xl', 10),
    11: getOffsetSpan('xl', 11),
    12: getOffsetSpan('xl', 12)
  },
  xxl: {
    1: getOffsetSpan('xxl', 1),
    2: getOffsetSpan('xxl', 2),
    3: getOffsetSpan('xxl', 3),
    4: getOffsetSpan('xxl', 4),
    5: getOffsetSpan('xxl', 5),
    6: getOffsetSpan('xxl', 6),
    7: getOffsetSpan('xxl', 7),
    8: getOffsetSpan('xxl', 8),
    9: getOffsetSpan('xxl', 9),
    10: getOffsetSpan('xxl', 10),
    11: getOffsetSpan('xxl', 11),
    12: getOffsetSpan('xxl', 12)
  }
};
export const order = {
  1: style({
    order: 1
  }, 'grid-col-order-1'),
  2: style({
    order: 2
  }, 'grid-col-order-2'),
  3: style({
    order: 3
  }, 'grid-col-order-3'),
  4: style({
    order: 4
  }, 'grid-col-order-4'),
  5: style({
    order: 5
  }, 'grid-col-order-5'),
  6: style({
    order: 6
  }, 'grid-col-order-6'),
  7: style({
    order: 7
  }, 'grid-col-order-7'),
  8: style({
    order: 8
  }, 'grid-col-order-8'),
  9: style({
    order: 9
  }, 'grid-col-order-9'),
  10: style({
    order: 10
  }, 'grid-col-order-10'),
  11: style({
    order: 11
  }, 'grid-col-order-11'),
  12: style({
    order: 12
  }, 'grid-col-order-12'),
  'last': style({
    order: 13
  }, 'grid-col-order-last'),
  'first': style({
    order: -1
  }, 'grid-col-order-first'),
  xs: {
    1: getOrderSpan('xs', 1),
    2: getOrderSpan('xs', 2),
    3: getOrderSpan('xs', 3),
    4: getOrderSpan('xs', 4),
    5: getOrderSpan('xs', 5),
    6: getOrderSpan('xs', 6),
    7: getOrderSpan('xs', 7),
    8: getOrderSpan('xs', 8),
    9: getOrderSpan('xs', 9),
    10: getOrderSpan('xs', 10),
    11: getOrderSpan('xs', 11),
    12: getOrderSpan('xs', 12),
    last: getOrderSpan('xs', 13),
    first: getOrderSpan('xs', -1)
  },
  sm: {
    1: getOrderSpan('sm', 1),
    2: getOrderSpan('sm', 2),
    3: getOrderSpan('sm', 3),
    4: getOrderSpan('sm', 4),
    5: getOrderSpan('sm', 5),
    6: getOrderSpan('sm', 6),
    7: getOrderSpan('sm', 7),
    8: getOrderSpan('sm', 8),
    9: getOrderSpan('sm', 9),
    10: getOrderSpan('sm', 10),
    11: getOrderSpan('sm', 11),
    12: getOrderSpan('sm', 12),
    last: getOrderSpan('sm', 13),
    first: getOrderSpan('sm', -1)
  },
  md: {
    1: getOrderSpan('md', 1),
    2: getOrderSpan('md', 2),
    3: getOrderSpan('md', 3),
    4: getOrderSpan('md', 4),
    5: getOrderSpan('md', 5),
    6: getOrderSpan('md', 6),
    7: getOrderSpan('md', 7),
    8: getOrderSpan('md', 8),
    9: getOrderSpan('md', 9),
    10: getOrderSpan('md', 10),
    11: getOrderSpan('md', 11),
    12: getOrderSpan('md', 12),
    last: getOrderSpan('md', 13),
    first: getOrderSpan('md', -1)
  },
  lg: {
    1: getOrderSpan('lg', 1),
    2: getOrderSpan('lg', 2),
    3: getOrderSpan('lg', 3),
    4: getOrderSpan('lg', 4),
    5: getOrderSpan('lg', 5),
    6: getOrderSpan('lg', 6),
    7: getOrderSpan('lg', 7),
    8: getOrderSpan('lg', 8),
    9: getOrderSpan('lg', 9),
    10: getOrderSpan('lg', 10),
    11: getOrderSpan('lg', 11),
    12: getOrderSpan('lg', 12),
    last: getOrderSpan('lg', 13),
    first: getOrderSpan('lg', -1)
  },
  xl: {
    1: getOrderSpan('xl', 1),
    2: getOrderSpan('xl', 2),
    3: getOrderSpan('xl', 3),
    4: getOrderSpan('xl', 4),
    5: getOrderSpan('xl', 5),
    6: getOrderSpan('xl', 6),
    7: getOrderSpan('xl', 7),
    8: getOrderSpan('xl', 8),
    9: getOrderSpan('xl', 9),
    10: getOrderSpan('xl', 10),
    11: getOrderSpan('xl', 11),
    12: getOrderSpan('xl', 12),
    last: getOrderSpan('xl', 13),
    first: getOrderSpan('xl', -1)
  },
  xxl: {
    1: getOrderSpan('xxl', 1),
    2: getOrderSpan('xxl', 2),
    3: getOrderSpan('xxl', 3),
    4: getOrderSpan('xxl', 4),
    5: getOrderSpan('xxl', 5),
    6: getOrderSpan('xxl', 6),
    7: getOrderSpan('xxl', 7),
    8: getOrderSpan('xxl', 8),
    9: getOrderSpan('xxl', 9),
    10: getOrderSpan('xxl', 10),
    11: getOrderSpan('xxl', 11),
    12: getOrderSpan('xxl', 12),
    last: getOrderSpan('xxl', 13),
    first: getOrderSpan('xxl', -1)
  }
};
export const justifyContent = {
  'start': style({
    justifyContent: 'flex-start !important'
  }, 'grid-justify-content-start'),
  'end': style({
    justifyContent: 'flex-end !important'
  }, 'grid-justify-content-end'),
  'center': style({
    justifyContent: 'center !important'
  }, 'grid-justify-content-center'),
  'between': style({
    justifyContent: 'space-between !important'
  }, 'grid-justify-content-between'),
  'around': style({
    justifyContent: 'space-around !important'
  }, 'grid-justify-content-around'),
  xs: {
    'start': getJustifyContentBreakpoint('xs', 'start', 'flex-start'),
    'end': getJustifyContentBreakpoint('xs', 'end', 'flex-end'),
    'center': getJustifyContentBreakpoint('xs', 'center', 'center'),
    'between': getJustifyContentBreakpoint('xs', 'between', 'space-between'),
    'around': getJustifyContentBreakpoint('xs', 'around', 'space-around')
  },
  sm: {
    'start': getJustifyContentBreakpoint('sm', 'start', 'flex-start'),
    'end': getJustifyContentBreakpoint('sm', 'end', 'flex-end'),
    'center': getJustifyContentBreakpoint('sm', 'center', 'center'),
    'between': getJustifyContentBreakpoint('sm', 'between', 'space-between'),
    'around': getJustifyContentBreakpoint('sm', 'around', 'space-around')
  },
  md: {
    'start': getJustifyContentBreakpoint('md', 'start', 'flex-start'),
    'end': getJustifyContentBreakpoint('md', 'end', 'flex-end'),
    'center': getJustifyContentBreakpoint('md', 'center', 'center'),
    'between': getJustifyContentBreakpoint('md', 'between', 'space-between'),
    'around': getJustifyContentBreakpoint('md', 'around', 'space-around')
  },
  lg: {
    'start': getJustifyContentBreakpoint('lg', 'start', 'flex-start'),
    'end': getJustifyContentBreakpoint('lg', 'end', 'flex-end'),
    'center': getJustifyContentBreakpoint('lg', 'center', 'center'),
    'between': getJustifyContentBreakpoint('lg', 'between', 'space-between'),
    'around': getJustifyContentBreakpoint('lg', 'around', 'space-around')
  },
  xl: {
    'start': getJustifyContentBreakpoint('xl', 'start', 'flex-start'),
    'end': getJustifyContentBreakpoint('xl', 'end', 'flex-end'),
    'center': getJustifyContentBreakpoint('xl', 'center', 'center'),
    'between': getJustifyContentBreakpoint('xl', 'between', 'space-between'),
    'around': getJustifyContentBreakpoint('xl', 'around', 'space-around')
  },
  xxl: {
    'start': getJustifyContentBreakpoint('xxl', 'start', 'flex-start'),
    'end': getJustifyContentBreakpoint('xxl', 'end', 'flex-end'),
    'center': getJustifyContentBreakpoint('xxl', 'center', 'center'),
    'between': getJustifyContentBreakpoint('xxl', 'between', 'space-between'),
    'around': getJustifyContentBreakpoint('xxl', 'around', 'space-around')
  }
};
export const alignSelf = {
  'auto': style({
    alignSelf: 'auto !important'
  }, 'grid-align-self-auto'),
  'start': style({
    alignSelf: 'flex-start !important'
  }, 'grid-align-self-start'),
  'end': style({
    alignSelf: 'flex-end !important'
  }, 'grid-align-self-end'),
  'center': style({
    alignSelf: 'center !important'
  }, 'grid-align-self-center'),
  'baseline': style({
    alignSelf: 'baseline !important'
  }, 'grid-align-self-baseline'),
  'stretch': style({
    alignSelf: 'stretch !important'
  }, 'grid-align-self-stretch'),
  xs: {
    'auto': getAlignSelfBreakpoint('xs', 'auto', 'auto'),
    'start': getAlignSelfBreakpoint('xs', 'start', 'flex-start'),
    'end': getAlignSelfBreakpoint('xs', 'end', 'flex-end'),
    'center': getAlignSelfBreakpoint('xs', 'center', 'center'),
    'baseline': getAlignSelfBreakpoint('xs', 'baseline', 'baseline'),
    'stretch': getAlignSelfBreakpoint('xs', 'stretch', 'stretch')
  },
  sm: {
    'auto': getAlignSelfBreakpoint('sm', 'auto', 'auto'),
    'start': getAlignSelfBreakpoint('sm', 'start', 'flex-start'),
    'end': getAlignSelfBreakpoint('sm', 'end', 'flex-end'),
    'center': getAlignSelfBreakpoint('sm', 'center', 'center'),
    'baseline': getAlignSelfBreakpoint('sm', 'baseline', 'baseline'),
    'stretch': getAlignSelfBreakpoint('sm', 'stretch', 'stretch')
  },
  md: {
    'auto': getAlignSelfBreakpoint('md', 'auto', 'auto'),
    'start': getAlignSelfBreakpoint('md', 'start', 'flex-start'),
    'end': getAlignSelfBreakpoint('md', 'end', 'flex-end'),
    'center': getAlignSelfBreakpoint('md', 'center', 'center'),
    'baseline': getAlignSelfBreakpoint('md', 'baseline', 'baseline'),
    'stretch': getAlignSelfBreakpoint('md', 'stretch', 'stretch')
  },
  lg: {
    'auto': getAlignSelfBreakpoint('lg', 'auto', 'auto'),
    'start': getAlignSelfBreakpoint('lg', 'start', 'flex-start'),
    'end': getAlignSelfBreakpoint('lg', 'end', 'flex-end'),
    'center': getAlignSelfBreakpoint('lg', 'center', 'center'),
    'baseline': getAlignSelfBreakpoint('lg', 'baseline', 'baseline'),
    'stretch': getAlignSelfBreakpoint('lg', 'stretch', 'stretch')
  },
  xl: {
    'auto': getAlignSelfBreakpoint('xl', 'auto', 'auto'),
    'start': getAlignSelfBreakpoint('xl', 'start', 'flex-start'),
    'end': getAlignSelfBreakpoint('xl', 'end', 'flex-end'),
    'center': getAlignSelfBreakpoint('xl', 'center', 'center'),
    'baseline': getAlignSelfBreakpoint('xl', 'baseline', 'baseline'),
    'stretch': getAlignSelfBreakpoint('xl', 'stretch', 'stretch')
  },
  xxl: {
    'auto': getAlignSelfBreakpoint('xxl', 'auto', 'auto'),
    'start': getAlignSelfBreakpoint('xxl', 'start', 'flex-start'),
    'end': getAlignSelfBreakpoint('xxl', 'end', 'flex-end'),
    'center': getAlignSelfBreakpoint('xxl', 'center', 'center'),
    'baseline': getAlignSelfBreakpoint('xxl', 'baseline', 'baseline'),
    'stretch': getAlignSelfBreakpoint('xxl', 'stretch', 'stretch')
  }
};
export const alignItems = {
  'start': style({
    alignItems: 'flex-start !important'
  }, 'grid-align-items-start'),
  'end': style({
    alignItems: 'flex-end !important'
  }, 'grid-align-items-end'),
  'center': style({
    alignItems: 'center !important'
  }, 'grid-align-items-center'),
  'baseline': style({
    alignItems: 'baseline !important'
  }, 'grid-align-items-baseline'),
  'stretch': style({
    alignItems: 'stretch !important'
  }, 'grid-align-items-stretch'),
  xs: {
    'start': getAlignItemsBreakpoint('xs', 'start', 'flex-start'),
    'end': getAlignItemsBreakpoint('xs', 'end', 'flex-end'),
    'center': getAlignItemsBreakpoint('xs', 'center', 'center'),
    'baseline': getAlignItemsBreakpoint('xs', 'baseline', 'baseline'),
    'stretch': getAlignItemsBreakpoint('xs', 'stretch', 'stretch')
  },
  sm: {
    'start': getAlignItemsBreakpoint('sm', 'start', 'flex-start'),
    'end': getAlignItemsBreakpoint('sm', 'end', 'flex-end'),
    'center': getAlignItemsBreakpoint('sm', 'center', 'center'),
    'baseline': getAlignItemsBreakpoint('sm', 'baseline', 'baseline'),
    'stretch': getAlignItemsBreakpoint('sm', 'stretch', 'stretch')
  },
  md: {
    'start': getAlignItemsBreakpoint('md', 'start', 'flex-start'),
    'end': getAlignItemsBreakpoint('md', 'end', 'flex-end'),
    'center': getAlignItemsBreakpoint('md', 'center', 'center'),
    'baseline': getAlignItemsBreakpoint('md', 'baseline', 'baseline'),
    'stretch': getAlignItemsBreakpoint('md', 'stretch', 'stretch')
  },
  lg: {
    'start': getAlignItemsBreakpoint('lg', 'start', 'flex-start'),
    'end': getAlignItemsBreakpoint('lg', 'end', 'flex-end'),
    'center': getAlignItemsBreakpoint('lg', 'center', 'center'),
    'baseline': getAlignItemsBreakpoint('lg', 'baseline', 'baseline'),
    'stretch': getAlignItemsBreakpoint('lg', 'stretch', 'stretch')
  },
  xl: {
    'start': getAlignItemsBreakpoint('xl', 'start', 'flex-start'),
    'end': getAlignItemsBreakpoint('xl', 'end', 'flex-end'),
    'center': getAlignItemsBreakpoint('xl', 'center', 'center'),
    'baseline': getAlignItemsBreakpoint('xl', 'start', 'baseline'),
    'stretch': getAlignItemsBreakpoint('xl', 'stretch', 'stretch')
  },
  xxl: {
    'start': getAlignItemsBreakpoint('xxl', 'start', 'flex-start'),
    'end': getAlignItemsBreakpoint('xxl', 'end', 'flex-end'),
    'center': getAlignItemsBreakpoint('xxl', 'center', 'center'),
    'baseline': getAlignItemsBreakpoint('xxl', 'baseline', 'baseline'),
    'stretch': getAlignItemsBreakpoint('xxl', 'stretch', 'stretch')
  }
};
export const alignContent = {
  'start': style({
    alignContent: 'flex-start !important'
  }, 'grid-align-content-start'),
  'end': style({
    alignContent: 'flex-end'
  }, 'grid-align-content-end'),
  'center': style({
    alignContent: 'center !important'
  }, 'grid-align-content-center'),
  'between': style({
    alignContent: 'space-between !important'
  }, 'grid-align-content-between'),
  'around': style({
    alignContent: 'space-around !important'
  }, 'grid-align-content-around'),
  'stretch': style({
    alignContent: 'stretch !important'
  }, 'grid-align-content-stretch'),
  xs: {
    'start': getAlignContentBreakpoint('xs', 'start', 'flex-start'),
    'end': getAlignContentBreakpoint('xs', 'end', 'flex-end'),
    'center': getAlignContentBreakpoint('xs', 'center', 'center'),
    'between': getAlignContentBreakpoint('xs', 'between', 'space-between'),
    'around': getAlignContentBreakpoint('xs', 'around', 'space-around'),
    'stretch': getAlignContentBreakpoint('xs', 'stretch', 'stretch')
  },
  sm: {
    'start': getAlignContentBreakpoint('sm', 'start', 'flex-start'),
    'end': getAlignContentBreakpoint('sm', 'end', 'flex-end'),
    'center': getAlignContentBreakpoint('sm', 'center', 'center'),
    'between': getAlignContentBreakpoint('sm', 'between', 'space-between'),
    'around': getAlignContentBreakpoint('sm', 'around', 'space-around'),
    'stretch': getAlignContentBreakpoint('sm', 'stretch', 'stretch')
  },
  md: {
    'start': getAlignContentBreakpoint('md', 'start', 'flex-start'),
    'end': getAlignContentBreakpoint('md', 'end', 'flex-end'),
    'center': getAlignContentBreakpoint('md', 'center', 'center'),
    'between': getAlignContentBreakpoint('md', 'between', 'space-between'),
    'around': getAlignContentBreakpoint('md', 'around', 'space-around'),
    'stretch': getAlignContentBreakpoint('md', 'stretch', 'stretch')
  },
  lg: {
    'start': getAlignContentBreakpoint('lg', 'start', 'flex-start'),
    'end': getAlignContentBreakpoint('lg', 'end', 'flex-end'),
    'center': getAlignContentBreakpoint('lg', 'center', 'center'),
    'between': getAlignContentBreakpoint('lg', 'between', 'space-between'),
    'around': getAlignContentBreakpoint('lg', 'around', 'space-around'),
    'stretch': getAlignContentBreakpoint('lg', 'stretch', 'stretch')
  },
  xl: {
    'start': getAlignContentBreakpoint('xl', 'start', 'flex-start'),
    'end': getAlignContentBreakpoint('xl', 'end', 'flex-end'),
    'center': getAlignContentBreakpoint('xl', 'center', 'center'),
    'between': getAlignContentBreakpoint('xl', 'between', 'space-between'),
    'around': getAlignContentBreakpoint('xl', 'around', 'space-around'),
    'stretch': getAlignContentBreakpoint('xl', 'stretch', 'stretch')
  },
  xxl: {
    'start': getAlignContentBreakpoint('xxl', 'start', 'flex-start'),
    'end': getAlignContentBreakpoint('xxl', 'end', 'flex-end'),
    'center': getAlignContentBreakpoint('xxl', 'center', 'center'),
    'between': getAlignContentBreakpoint('xxl', 'between', 'space-between'),
    'around': getAlignContentBreakpoint('xxl', 'around', 'space-around'),
    'stretch': getAlignContentBreakpoint('xxl', 'stretch', 'stretch')
  }
};
export const display = {
  'none': style({
    display: 'none !important'
  }, 'grid-display-none'),
  'inline': style({
    display: 'inline !important'
  }, 'grid-display-inline'),
  'inline-block': style({
    display: 'inline-block !important'
  }, 'grid-display-inline-block'),
  'block': style({
    display: 'block !important'
  }, 'grid-display-block'),
  'table': style({
    display: 'table !important'
  }, 'grid-display-table'),
  'table-row': style({
    display: 'table-row !important'
  }, 'grid-display-table-row'),
  'table-cell': style({
    display: 'table-cell !important'
  }, 'grid-display-table-cell'),
  'flex': style({
    display: 'flex !important '
  }, 'grid-display-flex'),
  xs: {
    'none': getDisplayBreakpoint('xs', 'none'),
    'inline': getDisplayBreakpoint('xs', 'inline'),
    'inline-block': getDisplayBreakpoint('xs', 'inline-block'),
    'block': getDisplayBreakpoint('xs', 'block'),
    'table': getDisplayBreakpoint('xs', 'table'),
    'table-row': getDisplayBreakpoint('xs', 'table-row'),
    'table-cell': getDisplayBreakpoint('xs', 'table-cell'),
    'flex': getDisplayBreakpoint('xs', 'flex')
  },
  sm: {
    'none': getDisplayBreakpoint('sm', 'none'),
    'inline': getDisplayBreakpoint('sm', 'inline'),
    'inline-block': getDisplayBreakpoint('sm', 'inline-block'),
    'block': getDisplayBreakpoint('sm', 'block'),
    'table': getDisplayBreakpoint('sm', 'table'),
    'table-row': getDisplayBreakpoint('sm', 'table-row'),
    'table-cell': getDisplayBreakpoint('sm', 'table-cell'),
    'flex': getDisplayBreakpoint('sm', 'flex')
  },
  md: {
    'none': getDisplayBreakpoint('md', 'none'),
    'inline': getDisplayBreakpoint('md', 'inline'),
    'inline-block': getDisplayBreakpoint('md', 'inline-block'),
    'block': getDisplayBreakpoint('md', 'block'),
    'table': getDisplayBreakpoint('md', 'table'),
    'table-row': getDisplayBreakpoint('md', 'table-row'),
    'table-cell': getDisplayBreakpoint('md', 'table-cell'),
    'flex': getDisplayBreakpoint('md', 'flex')
  },
  lg: {
    'none': getDisplayBreakpoint('lg', 'none'),
    'inline': getDisplayBreakpoint('lg', 'inline'),
    'inline-block': getDisplayBreakpoint('lg', 'inline-block'),
    'block': getDisplayBreakpoint('lg', 'block'),
    'table': getDisplayBreakpoint('lg', 'table'),
    'table-row': getDisplayBreakpoint('lg', 'table-row'),
    'table-cell': getDisplayBreakpoint('lg', 'table-cell'),
    'flex': getDisplayBreakpoint('lg', 'flex')
  },
  xl: {
    'none': getDisplayBreakpoint('xl', 'none'),
    'inline': getDisplayBreakpoint('xl', 'inline'),
    'inline-block': getDisplayBreakpoint('xl', 'inline-block'),
    'block': getDisplayBreakpoint('xl', 'block'),
    'table': getDisplayBreakpoint('xl', 'table'),
    'table-row': getDisplayBreakpoint('xl', 'table-row'),
    'table-cell': getDisplayBreakpoint('xl', 'table-cell'),
    'flex': getDisplayBreakpoint('xl', 'flex')
  },
  xxl: {
    'none': getDisplayBreakpoint('xxl', 'none'),
    'inline': getDisplayBreakpoint('xxl', 'inline'),
    'inline-block': getDisplayBreakpoint('xxl', 'inline-block'),
    'block': getDisplayBreakpoint('xxl', 'block'),
    'table': getDisplayBreakpoint('xxl', 'table'),
    'table-row': getDisplayBreakpoint('xxl', 'table-row'),
    'table-cell': getDisplayBreakpoint('xxl', 'table-cell'),
    'flex': getDisplayBreakpoint('xxl', 'flex')
  }
};
export const flex = {
  'row': style({
    msFlexDirection: 'row',
    flexDirection: 'row'
  }, 'grid-flex-row'),
  'column': style({
    msFlexDirection: 'column',
    flexDirection: 'column'
  }, 'grid-flex-column'),
  'row-reverse': style({
    msFlexDirection: 'row-reverse',
    flexDirection: 'row-reverse'
  }, 'grid-flex-row-reverse'),
  'column-reverse': style({
    msFlexDirection: 'column-reverse',
    flexDirection: 'column-reverse'
  }, 'grid-flex-column-reverse'),
  'wrap-reverse': style({
    flexWrap: 'wrap-reverse'
  }, 'grid-flex-wrap-reverse'),
  'fill': style({
    msFlex: '1 1 auto',
    flex: '1 1 auto'
  }, 'grid-flex-fill'),
  'grow-0': style({
    msFlexPositive: '0',
    flexGrow: '0'
  }, 'grid-flex-grow-0'),
  'grow-1': style({
    msFlexPositive: '1',
    flexGrow: '1'
  }, 'grid-flex-grow-1'),
  'shrink-0': style({
    flexShrink: '0'
  }, 'grid-flex-shrink-0'),
  'shrink-1': style({
    flexShrink: '1'
  }, 'grid-flex-shrink-1'),
  xs: {
    'row': getFlexBreakpoint('xs', 'row'),
    'column': getFlexBreakpoint('xs', 'column'),
    'row-reverse': getFlexBreakpoint('xs', 'row-reverse'),
    'column-reverse': getFlexBreakpoint('xs', 'column-reverse'),
    'wrap-reverse': getFlexBreakpoint('xs', 'wrap-reverse'),
    'fill': getFlexBreakpoint('xs', 'fill'),
    'grow-0': getFlexBreakpoint('xs', 'grow-0'),
    'grow-1': getFlexBreakpoint('xs', 'grow-1'),
    'shrink-0': getFlexBreakpoint('xs', 'shrink-0'),
    'shrink-1': getFlexBreakpoint('xs', 'shrink-1')
  },
  sm: {
    'row': getFlexBreakpoint('sm', 'row'),
    'column': getFlexBreakpoint('sm', 'column'),
    'row-reverse': getFlexBreakpoint('sm', 'row-reverse'),
    'column-reverse': getFlexBreakpoint('sm', 'column-reverse'),
    'wrap-reverse': getFlexBreakpoint('sm', 'wrap-reverse'),
    'fill': getFlexBreakpoint('sm', 'fill'),
    'grow-0': getFlexBreakpoint('sm', 'grow-0'),
    'grow-1': getFlexBreakpoint('sm', 'grow-1'),
    'shrink-0': getFlexBreakpoint('sm', 'shrink-0'),
    'shrink-1': getFlexBreakpoint('sm', 'shrink-1')
  },
  md: {
    'row': getFlexBreakpoint('md', 'row'),
    'column': getFlexBreakpoint('md', 'column'),
    'row-reverse': getFlexBreakpoint('md', 'row-reverse'),
    'column-reverse': getFlexBreakpoint('md', 'column-reverse'),
    'wrap-reverse': getFlexBreakpoint('md', 'wrap-reverse'),
    'fill': getFlexBreakpoint('md', 'fill'),
    'grow-0': getFlexBreakpoint('md', 'grow-0'),
    'grow-1': getFlexBreakpoint('md', 'grow-1'),
    'shrink-0': getFlexBreakpoint('md', 'shrink-0'),
    'shrink-1': getFlexBreakpoint('md', 'shrink-1')
  },
  lg: {
    'row': getFlexBreakpoint('lg', 'row'),
    'column': getFlexBreakpoint('lg', 'column'),
    'row-reverse': getFlexBreakpoint('lg', 'row-reverse'),
    'column-reverse': getFlexBreakpoint('lg', 'column-reverse'),
    'wrap-reverse': getFlexBreakpoint('lg', 'wrap-reverse'),
    'fill': getFlexBreakpoint('lg', 'fill'),
    'grow-0': getFlexBreakpoint('lg', 'grow-0'),
    'grow-1': getFlexBreakpoint('lg', 'grow-1'),
    'shrink-0': getFlexBreakpoint('lg', 'shrink-0'),
    'shrink-1': getFlexBreakpoint('lg', 'shrink-1')
  },
  xl: {
    'row': getFlexBreakpoint('xl', 'row'),
    'column': getFlexBreakpoint('xl', 'column'),
    'row-reverse': getFlexBreakpoint('xl', 'row-reverse'),
    'column-reverse': getFlexBreakpoint('xl', 'column-reverse'),
    'wrap-reverse': getFlexBreakpoint('xl', 'wrap-reverse'),
    'fill': getFlexBreakpoint('xl', 'fill'),
    'grow-0': getFlexBreakpoint('xl', 'grow-0'),
    'grow-1': getFlexBreakpoint('xl', 'grow-1'),
    'shrink-0': getFlexBreakpoint('xl', 'shrink-0'),
    'shrink-1': getFlexBreakpoint('xl', 'shrink-1')
  },
  xxl: {
    'row': getFlexBreakpoint('xxl', 'row'),
    'column': getFlexBreakpoint('xxl', 'column'),
    'row-reverse': getFlexBreakpoint('xxl', 'row-reverse'),
    'column-reverse': getFlexBreakpoint('xxl', 'column-reverse'),
    'wrap-reverse': getFlexBreakpoint('xxl', 'wrap-reverse'),
    'fill': getFlexBreakpoint('xxl', 'fill'),
    'grow-0': getFlexBreakpoint('xxl', 'grow-0'),
    'grow-1': getFlexBreakpoint('xxl', 'grow-1'),
    'shrink-0': getFlexBreakpoint('xxl', 'shrink-0'),
    'shrink-1': getFlexBreakpoint('xxl', 'shrink-1')
  }
};
export const containerFluid = style({
  width: '100%',
  paddingRight: tokens.space[200],
  paddingLeft: tokens.space[200],
  marginRight: 'auto',
  marginLeft: 'auto'
}, 'grid-container_fluid');
export const containerForm = style({
  width: '100%',
  paddingRight: 0,
  paddingLeft: 0,
  marginRight: 'auto',
  marginLeft: 'auto'
}, 'grid-container_form');
export const containerXxl = style({
  width: '100%',
  paddingRight: tokens.space[450],
  paddingLeft: tokens.space[450],
  marginRight: 'auto',
  marginLeft: 'auto',
  maxWidth: breakpoints.mediaXxl,
  '@media': {
    [`(min-width: ${breakpoints.mediaMd})`]: {
      paddingRight: tokens.space[400],
      paddingLeft: tokens.space[400],
      maxWidth: breakpoints.mediaXxl
    },
    [`(min-width: ${breakpoints.mediaXxl})`]: {
      paddingRight: tokens.space[600],
      paddingLeft: tokens.space[600],
      maxWidth: breakpoints.mediaXxl
    }
  }
}, 'grid-container_xxl');
export const container = style({
  width: '100%',
  paddingRight: tokens.space[150],
  paddingLeft: tokens.space[150],
  marginRight: 'auto',
  marginLeft: 'auto',
  '@media': {
    [`(min-width: ${breakpoints.mediaSm})`]: {
      paddingRight: tokens.space[300],
      paddingLeft: tokens.space[300],
      maxWidth: breakpoints.mediaSm
    },
    [`(min-width: ${breakpoints.mediaMd})`]: {
      paddingRight: tokens.space[450],
      paddingLeft: tokens.space[450],
      maxWidth: breakpoints.mediaMd
    },
    [`(min-width: ${breakpoints.mediaLg})`]: {
      paddingRight: tokens.space[450],
      paddingLeft: tokens.space[450],
      maxWidth: breakpoints.mediaLg
    },
    [`(min-width: ${breakpoints.mediaXl})`]: {
      paddingRight: tokens.space[450],
      paddingLeft: tokens.space[450],
      maxWidth: breakpoints.mediaXl
    }
  }
}, 'grid-container');
export const row = style({
  display: 'flex',
  flexWrap: 'wrap',
  marginRight: `calc(${tokens.space[150]} * -1)`,
  marginLeft: `calc(${tokens.space[150]} * -1)`
}, 'grid-row');
export const col = style({
  ...colBaseStyles,
  flexBasis: 0,
  msFlexPositive: 1,
  flexGrow: 1,
  maxWidth: '100%'
}, 'grid-col');
export const cols = {
  auto: style({
    msFlex: `0 0 auto`,
    flex: `0 0 auto`,
    maxWidth: 'none',
    width: 'auto'
  }, 'grid-col-auto'),
  1: getCol(1),
  2: getCol(2),
  3: getCol(3),
  4: getCol(4),
  5: getCol(5),
  6: getCol(6),
  7: getCol(7),
  8: getCol(8),
  9: getCol(9),
  10: getCol(10),
  11: getCol(11),
  12: getCol(12),
  xs: {
    1: getColSpan('xs', 1),
    2: getColSpan('xs', 2),
    3: getColSpan('xs', 3),
    4: getColSpan('xs', 4),
    5: getColSpan('xs', 5),
    6: getColSpan('xs', 6),
    7: getColSpan('xs', 7),
    8: getColSpan('xs', 8),
    9: getColSpan('xs', 9),
    10: getColSpan('xs', 10),
    11: getColSpan('xs', 11),
    12: getColSpan('xs', 12)
  },
  sm: {
    1: getColSpan('sm', 1),
    2: getColSpan('sm', 2),
    3: getColSpan('sm', 3),
    4: getColSpan('sm', 4),
    5: getColSpan('sm', 5),
    6: getColSpan('sm', 6),
    7: getColSpan('sm', 7),
    8: getColSpan('sm', 8),
    9: getColSpan('sm', 9),
    10: getColSpan('sm', 10),
    11: getColSpan('sm', 11),
    12: getColSpan('sm', 12)
  },
  md: {
    1: getColSpan('md', 1),
    2: getColSpan('md', 2),
    3: getColSpan('md', 3),
    4: getColSpan('md', 4),
    5: getColSpan('md', 5),
    6: getColSpan('md', 6),
    7: getColSpan('md', 7),
    8: getColSpan('md', 8),
    9: getColSpan('md', 9),
    10: getColSpan('md', 10),
    11: getColSpan('md', 11),
    12: getColSpan('md', 12)
  },
  lg: {
    1: getColSpan('lg', 1),
    2: getColSpan('lg', 2),
    3: getColSpan('lg', 3),
    4: getColSpan('lg', 4),
    5: getColSpan('lg', 5),
    6: getColSpan('lg', 6),
    7: getColSpan('lg', 7),
    8: getColSpan('lg', 8),
    9: getColSpan('lg', 9),
    10: getColSpan('lg', 10),
    11: getColSpan('lg', 11),
    12: getColSpan('lg', 12)
  },
  xl: {
    1: getColSpan('xl', 1),
    2: getColSpan('xl', 2),
    3: getColSpan('xl', 3),
    4: getColSpan('xl', 4),
    5: getColSpan('xl', 5),
    6: getColSpan('xl', 6),
    7: getColSpan('xl', 7),
    8: getColSpan('xl', 8),
    9: getColSpan('xl', 9),
    10: getColSpan('xl', 10),
    11: getColSpan('xl', 11),
    12: getColSpan('xl', 12)
  },
  xxl: {
    1: getColSpan('xxl', 1),
    2: getColSpan('xxl', 2),
    3: getColSpan('xxl', 3),
    4: getColSpan('xxl', 4),
    5: getColSpan('xxl', 5),
    6: getColSpan('xxl', 6),
    7: getColSpan('xxl', 7),
    8: getColSpan('xxl', 8),
    9: getColSpan('xxl', 9),
    10: getColSpan('xxl', 10),
    11: getColSpan('xxl', 11),
    12: getColSpan('xxl', 12)
  }
};
export const form = {
  'vspace': style({
    ...formBaseStyles
  }, 'grid-col-form-vspace'),
  'full': style({
    ...colBaseStyles,
    ...formBaseStyles,
    msFlex: '0 0 100%',
    flex: '0 0 100%',
    maxWidth: '100%'
  }, 'grid-col-form-full'),
  'half': style({
    ...colBaseStyles,
    ...formBaseStyles,
    msFlex: '0 0 50%',
    flex: '0 0 50%',
    maxWidth: '50%'
  }, 'grid-col-form-half'),
  '3qtr': style({
    ...colBaseStyles,
    ...formBaseStyles,
    msFlex: '0 0 75%',
    flex: '0 0 75%',
    maxWidth: '75%'
  }, 'grid-col-form-3qtr'),
  '1qtr': style({
    ...colBaseStyles,
    ...formBaseStyles,
    msFlex: '0 0 25%',
    flex: '0 0 25%',
    maxWidth: '25%'
  }, 'grid-col-form-1qtr'),
  'auto': style({
    ...colBaseStyles,
    ...formBaseStyles,
    msFlex: '0 0 auto',
    flex: '0 0 auto',
    maxWidth: 'auto'
  }, 'grid-col-form-auto')
};
export const noGutters = style({
  marginLeft: 0,
  marginRight: 0
}, 'grid-no-gutters');
globalStyle(`${noGutters} > ${col}, ${noGutters} > [class*='col-']`, {
  paddingLeft: 0,
  paddingRight: 0
});
__vanilla_filescope__.endFileScope();
